import http from "@/utils/http";
import { getCurrentLocale } from "@/utils/common";

const base = (token: string) => {
  const currentLocale = getCurrentLocale();
  return `${process.env.REACT_APP_SOPHYAPP_API_URL}/${currentLocale}/react/${token}`;
};

export const getDashboardData = async (token: string) => {
  const response = await http.get(`${base(token)}/dashboard/index`);
  return response.data;
};


